import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "el-dropdown-link" }

import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageDropdown',
  setup(__props) {

const { t, locale } = useI18n();

const changeLanguage = (language: string) => {
  // locale.value = language;
  locale.value = language;
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, null, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLanguage('zh-CN')))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" 中文 ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('en-US')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" English ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(t)("m.language")) + " ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("i", {
          class: "iconfont icon-xiala",
          style: {"font-size":"10px","margin-left":"5px"}
        }, null, -1))
      ])
    ]),
    _: 1
  }))
}
}

})